import React from 'react'
import { Modal, Button } from 'react-bootstrap'

function ConversationMembersModal(props){
  const { handleClose, show, conversation, handleDelete, canDelete } = props

  return(
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        Conversation Members
      </Modal.Header>
      <Modal.Body>
        {
          conversation && conversation.recipients.map((recipient, index) =>(
            <div key={index} className="mt-1">
              {recipient.name}
              <div className="d-inline text-secondary"> - [{recipient.email}]</div>
            </div>
          ))
        }
      </Modal.Body>
      <Modal.Footer class="d-flex justify-content-between p-3 border-top">
        <div>
          { canDelete && <Button className={"btn-outline-danger"} onClick={() => handleDelete(conversation)}>Delete Conversation</Button> }
        </div>
        <Button onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConversationMembersModal